import { getScreenName } from '../../../Utils/helper';
import { getPriceParams } from '../../../Utils/productPageUtils';

import { fireEvent } from '../../../Utils/fireEvent';

export const fireClickedCta = (sectionName, data) => {
  const { pricingParam, conversionParam } = getPriceParams(data);
  fireEvent({
    category: 'clicked_cta',
    cta: `chat with us`,
    screen_name: getScreenName(),
    page_url: typeof window != 'undefined' ? window.location.href : 'NA',
    section_name: sectionName,
    pricing_param: pricingParam,
    conversion_param: conversionParam,
    sku_nickname: data?.nickname?.slice(0, 99),
    pdp_variant: 'aplusplus',
    selling_price: data?.price,
    sku_type: data?.skuType,
    sku_id: data?.id,
    parent: `consult_now`,
  });
};

export const firePopupEvents = (category, cta) => {
  fireEvent({
    category: category,
    parent: `consult_now`,
    screen_name: getScreenName(),
    page_url: typeof window != 'undefined' ? window.location.href : 'NA',
    cta,
  });
};
